import { gql } from '@apollo/client';
const SAVE_ORDER_COMPONENT_VARIANT_DELIVERIES = gql `
  mutation SaveOrderComponentVariantDeliveries(
    $orderComponentVariantId: ID!
    $deliveries: [OrderComponentVariantDeliveryInput!]!
  ) {
    saveOrderComponentVariantDeliveries(
      orderComponentVariantId: $orderComponentVariantId
      deliveries: $deliveries
    ) {
      orderComponentVariant {
        id
        deliveries {
          id
          deliveryType
          quantityPlanned
          quantityCollected
          plannedDate
          collectedDate
          timelineStartDate
          timelineEndDate
          status
          deliveryOrdinal
        }
      }
    }
  }
`;
export default SAVE_ORDER_COMPONENT_VARIANT_DELIVERIES;
